// extracted by mini-css-extract-plugin
export var labelWrapper = "_ai-0";